import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
export var HelperText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.75rem;\n  margin-top: 2px;\n"], ["\n  color: ",
    ";\n  font-size: 0.75rem;\n  margin-top: 2px;\n"])), function (_a) {
    var error = _a.error, theme = _a.theme;
    return error ? theme.colors.error : theme.colors.text.primary;
});
var templateObject_1;
